function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "x602dcktla",
  d: "M12.693 17.05c.182-.184.285-.434.285-.693 0-.258-.103-.51-.285-.692-.184-.182-.435-.286-.693-.286-.258 0-.51.104-.693.286-.182.182-.285.434-.285.692 0 .259.103.51.285.693.182.182.435.286.693.286.258 0 .51-.104.693-.286zm.09-3.25v-3.64c0-.432-.35-.782-.783-.782-.432 0-.783.35-.783.782v3.64c0 .433.35.783.783.783.432 0 .783-.35.783-.783zm-7.656 4.678h13.746L12 6.368l-6.873 12.11zm15.09 1.565H3.783c-.279 0-.536-.148-.677-.388-.14-.24-.142-.538-.004-.78L11.32 4.396c.14-.245.4-.396.681-.396.282 0 .542.151.68.396l8.218 14.479c.138.242.136.54-.004.78s-.398.388-.677.388z"
}));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
  transform: "translate(-16 -12) translate(16 12)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "kmgb2j3p9b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#x602dcktla"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#CE2731",
  xlinkHref: "#x602dcktla"
}), /*#__PURE__*/React.createElement("g", {
  fill: "#FFF",
  mask: "url(#kmgb2j3p9b)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0H24V24H0z"
})))));

function SvgWarning(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.aea9ad7d.svg";
export { ForwardRef as ReactComponent };